module.exports = __webpack_public_path__ + "static/img/par1.93525157.png";